export default __webpack_public_path__ + "static/media/Inter-Bold.04a7d6ce.ttf";